import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  noop,
  isEmpty,
  map,
  isFunction,
} from 'lodash';
import Choices from 'choices.js';

const SelectOption = (props) => {
  const {
    option,
    valueKey,
    labelKey,
  } = props;
  if (!isEmpty(option.children)) {
    return (
      <optgroup label={option[labelKey]}>
        {
          option.children.map(child => (
            <SelectOption
              key={child[valueKey]}
              option={child}
              labelKey={labelKey}
              valueKey={valueKey}
            />
          ))
        }
      </optgroup>
    );
  }
  return (
    <option value={option[valueKey]}>
      {option[labelKey]}
    </option>
  );
};

SelectOption.propTypes = {
  option: PropTypes.object.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
};

const buildChoices = (props) => {
  const {
    options,
    labelKey,
    valueKey,
  } = props;

  if (isEmpty(options)) {
    return undefined;
  }

  const choices = map(options, option => (
    {
      value: option[valueKey],
      label: option[labelKey],
      disabled: option.disabled || false,
      choices: buildChoices({
        options: option.children || [],
        labelKey,
        valueKey,
      }),
    }
  ));
  return choices;
};

class SelectField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enableChoices: get(window, 'uuSearchSettings.enable-choices', false),
    };

    this.element = null;
  }

  componentDidMount() {
    const { enableChoices } = this.state;
    const {
      noChoices,
      removeButton,
      value,
      onSearch,
    } = this.props;

    if (enableChoices) {
      this.choices = new Choices(this.element, {
        shouldSort: false,
        removeItemButton: removeButton,
        noChoicesText: noChoices,
        searchChoices: !isFunction(onSearch),
        searchResultLimit: 50,
        searchFields: ['label'],
        fuseOptions: {
          threshold: 0,
        },
      });

      this.choices.setChoices(buildChoices(this.props), 'value', 'label', true);
      this.choices.setValueByChoice(value);

      if (isFunction(onSearch)) {
        this.element.addEventListener('search', onSearch);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { options, value } = this.props;
    const { enableChoices } = this.state;

    if (enableChoices && options !== nextProps.options) {
      this.choices.setChoices(buildChoices(nextProps), 'value', 'label', true);
      this.choices.removeActiveItems();
      this.choices.setValueByChoice(nextProps.value);
      if (isEmpty(nextProps.options)) {
        this.choices.clearStore();
      }
    }

    if (enableChoices && value !== nextProps.value) {
      this.choices.setValueByChoice(nextProps.value);
      if (isEmpty(nextProps.value)) {
        this.choices.removeActiveItems();
      }
    }
  }

  componentWillUnmount() {
    const { enableChoices } = this.state;
    const {
      onSearch,
    } = this.props;

    if (enableChoices && isFunction(onSearch)) {
      this.element.removeEventListener('search', onSearch);
    }
  }

  render() {
    const { enableChoices } = this.state;
    const {
      id,
      name,
      value,
      onChange,
      options,
      multiple,
      valueKey,
      labelKey,
      placeholder,
    } = this.props;

    return (
      <div className="uu-select-field">
        <select
          ref={(c) => { this.element = c; }}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          multiple={multiple}
        >
          {
            placeholder && <option placeholder="true" value="">{placeholder}</option>
          }
          {
            !enableChoices && options.map(option => (
              <SelectOption
                key={option[valueKey]}
                option={option}
                valueKey={valueKey}
                labelKey={labelKey}
              />
            ))
          }
        </select>
      </div>
    );
  }
}

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  options: PropTypes.array,
  multiple: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  placeholder: PropTypes.string,
  noChoices: PropTypes.string,
  removeButton: PropTypes.bool,
  onSearch: PropTypes.func,
};

SelectField.defaultProps = {
  value: '',
  onChange: noop,
  options: [],
  multiple: false,
  valueKey: 'value',
  labelKey: 'display_name',
  placeholder: null,
  noChoices: 'No Options to select',
  removeButton: true,
  onSearch: null,
};

export default SelectField;



// WEBPACK FOOTER //
// ./public/js/components/SelectField/index.jsx